// extracted by extract-css-chunks-webpack-plugin
module.exports = {"leftContent":"leftContent-10CiTh16","artical":"artical-s63bkTUs","cmt":"cmt-3G_huYU6"};